module.exports = __webpack_public_path__ + "img/qxl-banner.89b43791.png";